import {
    NgModule
} from '@angular/core';
import {
    Routes,
    RouterModule
} from '@angular/router';
const routes: Routes = [{
        path: '',
        redirectTo: 'login_',
        pathMatch: 'full'
    },
    {
        path: 'login_',
        loadChildren: () =>
            import ('./Login_/Login_.module').then(m => m.Login_PageModule),
    },
    {
        path: 'home',
        loadChildren: () =>
            import ('./Home/Home.module').then(m => m.HomePageModule),
    },
    {
        path: 'restaurantes',
        loadChildren: () =>
            import ('./Restaurantes/Restaurantes.module').then(m => m.RestaurantesPageModule),
    },
    {
        path: 'servicios/:idPDV',
        loadChildren: () =>
            import ('./Servicios/Servicios.module').then(m => m.ServiciosPageModule),
    },
    {
        path: 'platos/:idPDV/:idServicio/:idTipoPlato',
        loadChildren: () =>
            import ('./Platos/Platos.module').then(m => m.PlatosPageModule),
    },
    {
        path: 'spa_tipo_tratamiento/:id_Tipo_Spa',
        loadChildren: () =>
            import ('./Spa_Tipo_Tratamiento/Spa_Tipo_Tratamiento.module').then(m => m.Spa_Tipo_TratamientoPageModule),
    },
    {
        path: 'reservas_resto',
        loadChildren: () =>
            import ('./Reservas_Resto/Reservas_Resto.module').then(m => m.Reservas_RestoPageModule),
    },
    {
        path: 'resort',
        loadChildren: () =>
            import ('./Resort/Resort.module').then(m => m.ResortPageModule),
    },
    {
        path: 'resort_indoor',
        loadChildren: () =>
            import ('./Resort_Indoor/Resort_Indoor.module').then(m => m.Resort_IndoorPageModule),
    },
    {
        path: 'resort_outdoor',
        loadChildren: () =>
            import ('./Resort_Outdoor/Resort_Outdoor.module').then(m => m.Resort_OutdoorPageModule),
    },
    {
        path: 'reservas_spa',
        loadChildren: () =>
            import ('./Reservas_Spa/Reservas_Spa.module').then(m => m.Reservas_SpaPageModule),
    },
    {
        path: 'reservas_outdoor',
        loadChildren: () =>
            import ('./Reservas_Outdoor/Reservas_Outdoor.module').then(m => m.Reservas_OutdoorPageModule),
    },
    {
        path: 'spa',
        loadChildren: () =>
            import ('./Spa/Spa.module').then(m => m.SpaPageModule),
    },
    {
        path: 'config',
        loadChildren: () =>
            import ('./Configuracion/Configuracion.module').then(m => m.ConfiguracionPageModule),
    },
    {
        path: 'pedidos/:idPDV',
        loadChildren: () =>
            import ('./Pedidos/Pedidos.module').then(m => m.PedidosPageModule),
    },
    {
        path: 'spa_programas',
        loadChildren: () =>
            import ('./Spa_Programas/Spa_Programas.module').then(m => m.Spa_ProgramasPageModule),
    },
    {
        path: 'spa_especiales',
        loadChildren: () =>
            import ('./Spa_Especiales/Spa_Especiales.module').then(m => m.Spa_EspecialesPageModule),
    },
    {
        path: 'spa_memorables',
        loadChildren: () =>
            import ('./Spa_Memorables/Spa_Memorables.module').then(m => m.Spa_MemorablesPageModule),
    },
    {
        path: 'mis_reservas',
        loadChildren: () =>
            import ('./Mis_Reservas/Mis_Reservas.module').then(m => m.Mis_ReservasPageModule),
    },
    {
        path: 'tipo_plato_room',
        loadChildren: () =>
            import ('./Tipo_Plato_Room/Tipo_Plato_Room.module').then(m => m.Tipo_Plato_RoomPageModule),
    },
    {
        path: 'resort_piscina',
        loadChildren: () =>
            import ('./Resort_Piscina/Resort_Piscina.module').then(m => m.Resort_PiscinaPageModule),
    },
    {
        path: 'resort_marina',
        loadChildren: () =>
            import ('./Resort_Marina/Resort_Marina.module').then(m => m.Resort_MarinaPageModule),
    },
    {
        path: 'platos_room_desayuno',
        loadChildren: () =>
            import ('./Platos_Room_Desayuno/Platos_Room_Desayuno.module').then(m => m.Platos_Room_DesayunoPageModule),
    },
    {
        path: 'platos_room_entradas',
        loadChildren: () =>
            import ('./Platos_Room_Entradas/Platos_Room_Entradas.module').then(m => m.Platos_Room_EntradasPageModule),
    },
    {
        path: 'platos_room_principales',
        loadChildren: () =>
            import ('./Platos_Room_Principales/Platos_Room_Principales.module').then(m => m.Platos_Room_PrincipalesPageModule),
    },
    {
        path: 'platos_room_postres',
        loadChildren: () =>
            import ('./Platos_Room_Postres/Platos_Room_Postres.module').then(m => m.Platos_Room_PostresPageModule),
    },
    {
        path: 'platos_room_bebidas',
        loadChildren: () =>
            import ('./Platos_Room_Bebidas/Platos_Room_Bebidas.module').then(m => m.Platos_Room_BebidasPageModule),
    },
    {
        path: 'reservas_canchas',
        loadChildren: () =>
            import ('./Reservas_Canchas/Reservas_Canchas.module').then(m => m.Reservas_CanchasPageModule),
    },
    {
        path: 'platos_room_viandas',
        loadChildren: () =>
            import ('./Platos_Room_Viandas/Platos_Room_Viandas.module').then(m => m.Platos_Room_ViandasPageModule),
    },
    {
        path: 'platos_room_infantil',
        loadChildren: () =>
            import ('./Platos_Room_Infantil/Platos_Room_Infantil.module').then(m => m.Platos_Room_InfantilPageModule),
    },
    {
        path: 'platos_room_spa',
        loadChildren: () =>
            import ('./Platos_Room_Spa/Platos_Room_Spa.module').then(m => m.Platos_Room_SpaPageModule),
    },
    {
        path: 'platos_room_celiacos',
        loadChildren: () =>
            import ('./Platos_Room_Celiacos/Platos_Room_Celiacos.module').then(m => m.Platos_Room_CeliacosPageModule),
    },
    {
        path: 'tipo_bebidas',
        loadChildren: () =>
            import ('./Tipo_Bebidas/Tipo_Bebidas.module').then(m => m.Tipo_BebidasPageModule),
    },
    {
        path: 'novedades',
        loadChildren: () =>
            import ('./Novedades/Novedades.module').then(m => m.NovedadesPageModule),
    },
    {
        path: 'golf',
        loadChildren: () =>
            import ('./Golf/Golf.module').then(m => m.GolfPageModule),
    },
    {
        path: 'platos_room_minibares',
        loadChildren: () =>
            import ('./Platos_Room_Minibares/Platos_Room_Minibares.module').then(m => m.Platos_Room_MinibaresPageModule),
    },
    {
        path: 'reservas_piscina',
        loadChildren: () =>
            import ('./Reservas_Piscina/Reservas_Piscina.module').then(m => m.Reservas_PiscinaPageModule),
    },
    {
        path: 'reservas_indoor',
        loadChildren: () =>
            import ('./Reservas_Indoor/Reservas_Indoor.module').then(m => m.Reservas_IndoorPageModule),
    },
    {
        path: 'reservas_desayuno',
        loadChildren: () =>
            import ('./Reservas_Desayuno/Reservas_Desayuno.module').then(m => m.Reservas_DesayunoPageModule),
    },
    {
        path: 'reservas_nahuelitos',
        loadChildren: () =>
            import ('./Reservas_Nahuelitos/Reservas_Nahuelitos.module').then(m => m.Reservas_NahuelitosPageModule),
    },
    {
        path: 'cancelar_reservas',
        loadChildren: () =>
            import ('./Cancelar_Reservas/Cancelar_Reservas.module').then(m => m.Cancelar_ReservasPageModule),
    },
    {
        path: 'servicios_room/:idPDV',
        loadChildren: () =>
            import ('./Servicios_Room/Servicios_Room.module').then(m => m.Servicios_RoomPageModule),
    },
    {
        path: 'login_aux',
        loadChildren: () =>
            import ('./Login_Aux/Login_Aux.module').then(m => m.Login_AuxPageModule),
    },
    {
        path: 'recaptchav3',
        loadChildren: () =>
            import ('./recaptchav3/recaptchav3.module').then(m => m.recaptchav3PageModule),
    },
    {
        path: 'recaptchav2',
        loadChildren: () =>
            import ('./recaptchaV2/recaptchaV2.module').then(m => m.recaptchaV2PageModule),
    },
];
@NgModule({
    imports: [RouterModule.forRoot(
        routes, {
            enableTracing: false,
            useHash: true
        }
    )],
    exports: [RouterModule]
})
export class AppRoutingModule {}